import { IMAGES, BUSINESS } from "../../data/business";
import { Check } from "lucide-react";

const points = [
  "Locally owned & operated",
  "Reliable, friendly communication",
  "Respect for your home or business",
  "Detail-oriented in every space",
  "Flexible scheduling that fits you",
  "Great for homes, offices & churches",
];

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container-ss grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <div className="relative rounded-3xl overflow-hidden border border-slate-200 shadow-sm">
            <img
              src={IMAGES.teamCleaner}
              width="800"
              height="800"
              loading="lazy"
              decoding="async"
              alt="Friendly local cleaner from S.S. Cleaning Solutions"
              className="w-full h-[440px] object-cover"
            />
          </div>
        </div>
        <div className="lg:col-span-6 order-1 lg:order-2">
          <span className="pill mb-4">About S.S. Cleaning Solutions</span>
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            A local cleaning company that actually <span className="text-[#1E3A8A]">cares about the details</span>.
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed">
            S.S. Cleaning Solutions is a dependable local cleaning company serving Northwest Indiana.
            We take pride in detailed work, respectful service, and helping homes, churches, offices
            and businesses look and feel their best.
          </p>

          <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {points.map((p) => (
              <li key={p} className="flex items-start gap-2 text-slate-700">
                <span className="mt-0.5 h-6 w-6 rounded-full bg-emerald-100 text-emerald-700 inline-flex items-center justify-center">
                  <Check size={14} />
                </span>
                <span>{p}</span>
              </li>
            ))}
          </ul>

          {/* Real logo brand card */}
          <div className="mt-7 inline-flex items-center gap-4 bg-white border border-slate-200 rounded-2xl shadow-sm px-5 py-4">
            <img
              src={BUSINESS.logoSrc}
              alt="S.S. Cleaning Solutions logo"
              width="56"
              height="56"
              loading="lazy"
              className="h-14 w-14 object-contain"
            />
            <div>
              <div className="font-display font-semibold text-slate-900 leading-tight">
                S.S. Cleaning Solutions
              </div>
              <div className="text-xs text-slate-500">Residential & Commercial Cleaning</div>
              <div className="text-xs font-semibold text-[#1E3A8A] mt-0.5">
                Reliable • Detailed • Trustworthy
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
